import { Checkbox } from "@mui/material"
import { useSimilaritySelection } from "../similarity-selection-context"

export function SimilarityResultSelectedTask({ task, ...props }) {
    const { isTaskSelected, toggleTask } = useSimilaritySelection()
    return (
        <Checkbox
            data-cy="select-similar-task-check-box"
            size="small"
            sx={{ p: 0 }}
            checked={isTaskSelected(task)}
            onChange={() => toggleTask(task)}
            {...props}
        />
    )
}
